<his-multiselect-autocomplete
  [hisDdKey]="hisDdKey"
  [inputId]="inputId"
  [dataSource]="dataSource"
  (dataSourceAvailable)="setOptionList($event)"
  [limit]="limit"
  [field]="field"
  [group]="group()"
  [disabled]="disabled()"
  [showDropdownIcon]="showDropdownIcon"
  [removeSelectedOptionsFromDropdown]="removeSelectedOptionsFromDropdown()"
  (lazyLoadRequest)="loadOptions()"
  [optionList]="optionList()"
  [selectedOptions]="selectedOptionsModel()"
  (selectedOptionsChange)="onSelectedOptionsChange($event)"
  (openSelectionDialogRequest)="dialog.openOverlay( $event )">
</his-multiselect-autocomplete>

<his-multiselect-selected-options-list
  [hisDdKey]="hisDdKey"
  [disabled]="disabled()"
  [field]="field"
  [selectedOptions]="selectedOptionsModel()"
  (selectedOptionsChange)="onSelectedOptionsChange($event)"
  [maxDisplayedSelections]="maxDisplayedSelections">
</his-multiselect-selected-options-list>

<his-multiselect-selection-dialog #dialog
  [label]="label"
  [disabled]="disabled()"
  [showSelectButton]="showSelectButton()"
  [showDeleteButton]="showDeleteButton()"
  [selectButtonImage]="selectButtonImage"
  [selectButtonTooltip]="selectButtonTooltip"
  [enableTableFilter]="true"
  [customSortFunction]="customSort === false ? undefined : sortMethod"
  [maxRows]="maxRows"
  [resultRowsPerPage]="resultRowsPerPage"
  [optionList]="flatOptionList()"
  [selectedOptions]="selectedOptionsModel()"
  (selectedOptionsChange)="onSelectedOptionsChange($event)">
</his-multiselect-selection-dialog>